/**
 * @generated SignedSource<<bbd4763b4e72dfcca2feea512a5cf2e9>>
 * @relayHash 034f5abd4b0448f6771fb9118c165a4a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d357caba51d06750ef6f8eb3c193454fd70191f827d179526b86076ac07003e1

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HorizontalNavPlansQuery } from './HorizontalNavPlansQuery.graphql';

const node: PreloadableConcreteRequest<HorizontalNavPlansQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d357caba51d06750ef6f8eb3c193454fd70191f827d179526b86076ac07003e1",
    "metadata": {},
    "name": "HorizontalNavPlansQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
